import React from 'react';

const SectionHeader = ({ eyebrow, title, desc }) => (
  <div className='mb-8'>
    <div className='flex items-center gap-2.5 mb-2'>
      <div className='w-6 h-px bg-primary' />
      <span className='font-mono text-[10px] tracking-[0.18em] uppercase text-primary'>{eyebrow}</span>
    </div>
    <h2 className='font-display text-3xl text-foreground leading-tight mb-3'>{title}</h2>
    {desc && <p className='text-[15px] text-muted-foreground max-w-[640px] leading-relaxed'>{desc}</p>}
    <div className='h-px bg-gradient-to-r from-accent to-transparent mt-5 mb-9' />
  </div>
);

export { SectionHeader };
